// ============================================================================
// TASKSTATUSCONTROL.JS - COMPONENTE MODULAR PARA CONTROL DE ESTADO
// ============================================================================

import React from 'react';
import useToast from '../services/useToast';
import {
  CheckCircle,
  Clock,
  Play,
  RefreshCw,
  Shield,
  Flag
} from 'lucide-react';

function TaskStatusControl({
  task,
  isLoading,
  isAdmin,
  onStatusChange,
  onToggleSEO,
  onReopen
}) {
  const { showWarning } = useToast();

  return (
    <div className="task-status-panel">
      <div className="info-panel-header">
        <h3 className="info-panel-title">
          <Flag className="section-icon" />
          Estado
        </h3>
      </div>

      {/* Segmented control horizontal. El pill blanco se desliza al estado
          activo vía --seg-index; en estados fuera del control (borrador,
          cerrada) no se pinta. */}
      <div className="status-segmented">
        {['pendiente', 'en-curso', 'completada'].includes(task.estado) && (
          <span
            className="status-seg-pill"
            style={{ '--seg-index': ['pendiente', 'en-curso', 'completada'].indexOf(task.estado) }}
            aria-hidden="true"
          />
        )}
        <button
          className={`status-seg-btn ${task.estado === 'pendiente' ? 'active' : ''}`}
          onClick={() => onStatusChange('pendiente')}
          disabled={isLoading}
        >
          <Clock size={14} />
          Pendiente
        </button>

        <button
          className={`status-seg-btn ${task.estado === 'en-curso' ? 'active' : ''}`}
          onClick={() => onStatusChange('en-curso')}
          disabled={isLoading}
        >
          <Play size={14} />
          En curso
        </button>

        <button
          className={`status-seg-btn ${task.estado === 'completada' ? 'active' : ''}`}
          onClick={() => onStatusChange('completada')}
          disabled={isLoading}
        >
          <CheckCircle size={14} />
          Lista
        </button>
      </div>

      {/* Toggle SEO */}
      <div className="seo-toggle-row">
        <div className="seo-toggle-label">
          <Shield size={14} />
          Validación SEO
        </div>
        <button
          type="button"
          role="switch"
          aria-checked={!!task.validadoPorSEO}
          className={`seo-toggle ${task.validadoPorSEO ? 'on' : 'off'}`}
          onClick={isAdmin ? onToggleSEO : () => showWarning('Solo los administradores pueden cambiar la validación SEO')}
          disabled={isLoading}
          title={!isAdmin ? 'Solo los administradores pueden cambiar este estado' : ''}
        >
          <span className="seo-toggle-knob" />
        </button>
      </div>

      {/* Botón de reabrir si está completada */}
      {task.estado === 'completada' && (
        <button
          className="btn-reopen-task"
          onClick={onReopen}
          disabled={isLoading}
        >
          <RefreshCw className="reopen-icon" />
          Reabrir tarea
        </button>
      )}
    </div>
  );
}

export default TaskStatusControl;
